import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

export const AddCounterpartyCard: React.FC = () => {
  return (
    <div className="flex w-full items-center gap-2 rounded-lg border border-dashed border-gray-300 p-3 opacity-60 cursor-not-allowed">
      <PlusIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
      <span className="text-sm text-gray-400">Add counterparty</span>
    </div>
  );
};
